export default "__VITE_ASSET__BhT2vI9f__"